/* eslint-disable @typescript-eslint/no-empty-function */
import jwtDecode from 'jwt-decode'
import React, { createContext, useEffect, useState } from 'react'
import { UserProviderProps } from '../types/globalTypes'

interface UserContextProps {
  user: DecodedUser
  setUser: (user: DecodedUser) => void
  token: string
  setToken: (token: string) => void
  googleEmail: string
  setGoogleEmail: (email: string) => void
  googlePicture: string
  setGooglePicture: (photo: string) => void
  googleName: string
  setGoogleName: (name: string) => void
}

interface DecodedUser {
  map: any
  status: number
  id: string
  name: string
  email: string
  cnpj: string
  adminUser: boolean
  picture: string
  approved: string
  sub: number
  profileId: number
  permissions: string[]
}

const UserContext = createContext<UserContextProps>({
  user: {} as DecodedUser,
  setUser: () => {},
  token: '',
  setToken: () => {},
  googleEmail: '',
  setGoogleEmail: () => {},
  googlePicture: '',
  setGooglePicture: () => {},
  googleName: '',
  setGoogleName: () => {},
})

export default UserContext

export const UserProvider: React.FC<UserProviderProps> = ({ children }) => {
  const [user, setUser] = useState<DecodedUser>({} as DecodedUser)
  const [token, setToken] = useState<string>(
    localStorage.getItem('token') || '',
  )
  const [googleEmail, setGoogleEmail] = useState<string>('')
  const [googlePicture, setGooglePicture] = useState<string>('')
  const [googleName, setGoogleName] = useState<string>('')

  useEffect(() => {
    if (token) {
      const userDecode = jwtDecode(token) as DecodedUser
      setUser(userDecode)
    }
  }, [token])

  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
        token,
        setToken,
        googleEmail,
        setGoogleEmail,
        googlePicture,
        setGooglePicture,
        googleName,
        setGoogleName,
      }}
    >
      {children}
    </UserContext.Provider>
  )
}
